'use strict';

const scrollingText = document.querySelectorAll('.js-moving-title');

const setPosition = (step) => {
    scrollingText.forEach((text) => {
        const position = text.dataset.position;
        text.style.transform = `translateX(${position}%)`;
        text.dataset.position = position - step;

        if (position < -200) {
            text.dataset.position = 200;
        }
    });
};

const movingTitle = () => {
    setPosition(0.05);

    requestAnimationFrame(movingTitle);
};

function initializeEvents() {
    window.requestAnimationFrame(movingTitle);
    window.addEventListener('scroll', () => {
        setPosition(0.15);
    });
}

const adventMovingTitle = {
    init: function() {
        initializeEvents();
        movingTitle();
    }
};

module.exports = adventMovingTitle;
